import { Test360Competence } from '../types'
import { Test360Answers } from 'ducks/test360/reducer'

/**
 * Converts API answers format to Redux format
 * @param competences - Array of competences from API with questions and answers
 * @returns Test360Answers object in Redux format
 */
export const convertApiAnswersToRedux = (competences: Test360Competence[]): Test360Answers => {
  const reduxAnswers: Test360Answers = {}

  competences.forEach((competence) => {
    const competenceId = competence.competenceId

    // Initialize competence answers object
    reduxAnswers[competenceId] = {}

    competence.questions.forEach((question, questionIndex) => {
      // Initialize question answers object
      reduxAnswers[competenceId][questionIndex] = {}

      // If question has answers from API, convert them
      if (question.answers && Array.isArray(question.answers)) {
        question.answers.forEach((answer) => {
          // Convert assignment_id to string for consistency with existing format
          const evaluatedUserId = answer.assignment_id.toString()
          reduxAnswers[competenceId][questionIndex][evaluatedUserId] = answer.response_weight
        })
      }
    })
  })

  return reduxAnswers
}
